import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upload-overlay absolute-full-size" }
const _hoisted_2 = { class: "upload-border w-100 h-100 d-flex align-items-center text-center" }
const _hoisted_3 = { class: "w-100" }

import {computed, ref} from 'vue';
import ChatModal from "~/chat/vue/widget/ChatModal.vue";
import ChatUpload from "~/chat/vue/widget/form/ChatUpload.vue";
import {IChatUpload} from "~/chat/vue/widget/form/IChatUpload";
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "ChatUploadOverlay"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["new-files"],
  setup(__props, { emit: __emit }) {

let emits = __emit;

let chatUploadRef = ref<IChatUpload>();
let count = ref(0);


let visible = computed(() => {
    return count.value > 0;
});

function isFileDrag(e: DragEvent) {
    return e.dataTransfer.types.indexOf("Files") > -1;
}

function onDragEnter(e: DragEvent) {
    if (isFileDrag(e)) {
        count.value++;
    }
}

function onDragLeave(e: DragEvent) {
    if (isFileDrag(e)) {
        count.value--;
    }
}

function onDrop(e: DragEvent) {
    if (isFileDrag(e)) {
        count.value = 0;
        chatUploadRef.value.newFilesList(e.dataTransfer.files);
    }
}

return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", {
    onDragenter: _withModifiers(onDragEnter, ["stop","prevent"]),
    onDragleave: _withModifiers(onDragLeave, ["stop","prevent"]),
    onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"])),
    onDrop: _withModifiers(onDrop, ["stop","prevent"])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(visible))
          ? _withDirectives((_openBlock(), _createBlock(ChatModal, {
              key: 0,
              visible: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(__)("ATTACH_FILES")), 1)
                  ])
                ])
              ]),
              _: 1
            })), [
              [
                _directive_on_native,
                onDragEnter,
                "dragenter",
                {
                  stop: true,
                  prevent: true
                }
              ],
              [
                _directive_on_native,
                onDragLeave,
                "dragleave",
                {
                  stop: true,
                  prevent: true
                }
              ],
              [
                _directive_on_native,
                void 0,
                "dragover",
                {
                  stop: true,
                  prevent: true
                }
              ],
              [
                _directive_on_native,
                onDrop,
                "drop",
                {
                  stop: true,
                  prevent: true
                }
              ]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ChatUpload, {
      ref_key: "chatUploadRef",
      ref: chatUploadRef,
      onNewFiles: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('new-files', $event)))
    }, null, 512)
  ], 32))
}
}

})